const attention = {
  open: '打开提醒',
  close: '关闭提醒',
  title: '提醒',
  intro: '这里汇集需要你注意的新线索、人工请求和响应时限。',
  unreadCount: '{count} 条未读',
  markAll: '全部标为已读',
  filter: { all: '全部', unread: '未读', lead: '新线索', human: '请求人工' },
  kind: {
    lead_created: '收到新的有效线索',
    human_handoff_requested: '买家请求人工协助',
    sla_warning: '首次响应即将到期',
    sla_overdue: '响应时限已超时',
  },
  body: {
    lead_created: '买家已授权留下联络方式，请进入对应线索继续处理。',
    human_handoff_requested: '请打开本次 Airlock 原对话，或处理已经形成的关联线索。',
    sla_warning: '这条线索仍缺少当前阶段要求的人工动作。',
    sla_overdue: '锁定的响应截止时间已过，当前仍没有完成所需动作。',
  },
  target: { lead: '线索详情', conversation: '接待原对话' },
  openTarget: '去处理',
  markRead: '标为已读',
  read: '已读',
  unread: '未读',
  urgent: '优先',
  emptyTitle: '目前没有需要注意的事项',
  emptyBody: '新的业务事件会出现在这里，但不会因此改变线索处理状态。',
  loading: '正在检查新提醒…',
  failed: '暂时无法读取提醒。',
  retry: '重新尝试',
  newToast: '收到 {count} 条新提醒',
  boundary: '已读状态只属于提醒收件箱；分配、跟进和结果仍在线索流程中完成。',
  emailBoundary: '邮件是否发送服从企业设置；邮件失败不会丢失应用内提醒。',
  justNow: '刚刚',
  minutesAgo: '{count} 分钟前',
  hoursAgo: '{count} 小时前',
  daysAgo: '{count} 天前',
} as const

export default attention
